import React, { useContext } from 'react';
import FilterInput from '../../../components/filter-input';

import { id } from '../../../../filters/options/item-sku';

import { AdvancedSearchOrderContext } from '../../context';

import messages from './messages';

const ItemSkuFilter = () => {
  const { filters, updateFilter } = useContext(AdvancedSearchOrderContext);

  return <FilterInput filters={filters} id={id} labelMessage={messages.itemSku} updateFilter={updateFilter} />;
};

export default ItemSkuFilter;
